<template>
  <div id="settingsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex class="text-xs-right">
          <v-dialog persistent v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
              color="primary"
              round
              outline
              v-on="on">
              <v-icon left>settings</v-icon>
              {{ $t('setting.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          required
                          :disabled="editedIndex !== -1"
                          :rules="rules.required"
                          :items="settingType"
                          item-text="name"
                          item-value="id"
                          :label="$t('setting.type')"
                          :error-messages="errors.type"
                          v-model="editedItem.gst_setting_type_id">
                          <template slot="selection" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 1" xs12>
                        <v-select
                          required
                          :rules="rules.required"
                          :items="periodsType"
                          item-text="name"
                          item-value="id"
                          :label="$t('setting.selectPeriodType')"
                          :error-messages="errors.type"
                          v-model="editedItem.value.periodType">
                          <template slot="selection" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 1" xs12>
                        <v-select
                          required
                          :rules="rules.required"
                          :items="days"
                          item-text="name"
                          item-value="id"
                          :label="periodLabel"
                          :error-messages="errors.type"
                          v-model="editedItem.value.deadline">
                        </v-select>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 2" xs12>
                        <h3>{{$t('setting.requiredComment')}}:</h3>
                          <v-checkbox v-model="editedItem.value_expenseComment.fiscal.comment_required" :label="`CFDI (XML)`"></v-checkbox>
                          <v-checkbox v-model="editedItem.value_expenseComment.no_fiscal.comment_required" :label="$t('general.receipt')"></v-checkbox>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 3" xs12>
                          <v-text-field
                            v-model="editedItem.value_dateExtension.dateExtension"
                            :rules="rules.required"
                            :error-messages="errors.name"
                            :label="$t('setting.days')"
                          >
                          </v-text-field>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 4" xs12>
                        <v-autocomplete
                              clearable
                              :rules="rules.required"
                              :items="satMoneda"
                              item-text="descripcion"
                              item-value="id"
                              :label="$t('setting.selectCurrencyType')"
                              :filter="currencyFilter"
                              :error-messages="errors.currency"
                              v-model="editedItem.currency"
                              return-object
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Moneda }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                      </v-flex>
                      <v-flex v-if="editedItem.gst_setting_type_id === 5" xs12>
                        <v-autocomplete
                              clearable
                              :rules="rules.required"
                              :items="satPais"
                              item-text="descripcion"
                              item-value="id"
                              :label="$t('setting.selectCountryType')"
                              :filter="countryFilter"
                              :error-messages="errors.country"
                              v-model="editedItem.country"
                              return-object
                            >
                            <template slot="selection" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                            </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="primary darken-1"
                round
                flat
                @click="close">
                {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="save">
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table
        :items="companySettings"
        :loading="loadingItems"
        :headers="headers"
        hide-actions
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td width="60px">{{props.item.id}}</td>
          <td class="text-sm-center">{{$t('setting.' + props.item.setting_type.name)}}</td>
          <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 1">
            <v-layout>
              <v-flex xs6>
                <strong>{{$t('setting.periodType')}}:</strong>
                <b-badge pill variant="primary">
                  {{$t('setting.' + getPeriodType(props.item.value.periodType))}}
                </b-badge>
              </v-flex>
              <v-flex xs6>
                <strong>{{$t('setting.deadline')}}:</strong>
                <b-badge v-if="props.item.value.periodType === 1" pill variant="primary">
                  {{getWeekDay(props.item.value.deadline)}}
                </b-badge>
                <b-badge v-else pill variant="primary">
                  {{props.item.value.deadline}}
                </b-badge>
              </v-flex>
            </v-layout>
          </td>
          <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 2">
            <v-layout>
              <v-flex xs6>
                <strong>CFDI (XML)</strong>
                <b-badge pill variant="primary">
                  {{props.item.value.fiscal.comment_required ? $t('general.yes') : $t('general.no')}}
                </b-badge>
              </v-flex>
               <v-flex xs6>
                <strong>{{$t('general.receipt')}}</strong>
                <b-badge pill variant="primary">
                  {{props.item.value.no_fiscal.comment_required ? $t('general.yes') : $t('general.no')}}
                </b-badge>
              </v-flex>
            </v-layout>
          </td>
          <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 3">
            <v-layout>
              <v-flex xs6>
                <strong>{{$t('setting.days')}}:</strong>
                <b-badge pill variant="primary">
                  {{props.item.value.dateExtension}}
                </b-badge>
              </v-flex>
            </v-layout>
          </td>
          <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 4">
            <v-layout>
              <v-flex xs6>
                <strong>{{$t('setting.CurrencyType')}}:</strong>
                <b-badge pill variant="primary">
                  {{props.item.value.c_Moneda}}
                </b-badge>
              </v-flex>
            </v-layout>
          </td>
          <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 5">
            <v-layout>
              <v-flex xs6>
                <strong>{{$t('setting.CountryType')}}:</strong>
                <b-badge pill variant="primary">
                  {{props.item.value.c_Pais}}
                </b-badge>
              </v-flex>
            </v-layout>
          </td>
          <td width="200px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  outline
                  icon
                  color="info"
                  v-on="on"
                  @click="editItem(props.item)"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="props.item.gst_setting_type_id !== 3">
              <template v-slot:activator="{ on }">
              <v-btn
                outline
                icon
                color="error"
                v-on="on"
                @click="removed(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
              </template>
              <span>{{ $t('general.delete') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog persistente v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('setting.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { store } from '../store'
export default {
  name: 'settingsComponent',
  data () {
    return {
      dialog: false,
      userLogged: {},
      removeDialog: false,
      removedItem: {},
      editedIndex: -1,
      valid: true,
      settings: [],
      setting: null,
      monthDays: [
        {id: 1, name: '1'},
        {id: 2, name: '2'},
        {id: 3, name: '3'},
        {id: 4, name: '4'},
        {id: 5, name: '5'},
        {id: 6, name: '6'},
        {id: 7, name: '7'},
        {id: 8, name: '8'},
        {id: 9, name: '9'},
        {id: 10, name: '10'},
        {id: 11, name: '11'},
        {id: 12, name: '12'},
        {id: 13, name: '13'},
        {id: 14, name: '14'},
        {id: 15, name: '15'},
        {id: 16, name: '16'},
        {id: 17, name: '17'},
        {id: 18, name: '18'},
        {id: 19, name: '19'},
        {id: 20, name: '20'},
        {id: 20, name: '20'},
        {id: 21, name: '21'},
        {id: 22, name: '22'},
        {id: 23, name: '23'},
        {id: 24, name: '24'},
        {id: 25, name: '25'},
        {id: 26, name: '26'},
        {id: 27, name: '27'},
        {id: 28, name: '28'},
        {id: 29, name: '29'},
        {id: 30, name: '30'},
        {id: 31, name: '31'}
      ],
      periodsType: [],
      companies: [],
      settingType: [],
      satMoneda: [],
      satPais: [],
      editedItem: {
        company_id: 0,
        gst_setting_type_id: 0,
        currency: {
          id: 100,
          c_Moneda: 'MXN'
        },
        country: {
          id: 151,
          c_Pais: 'MEX'
        },
        value: {
          periodType: '',
          deadline: ''
        },
        value_expenseComment: {
          fiscal: {
            comment_required: null
          },
          no_fiscal: {
            comment_required: null
          }
        },
        value_dateExtension: {
          dateExtension: ''
        },
        original: null
      },
      defaultItem: {
        company_id: 0,
        gst_setting_type_id: 0,
        currency: {
          id: 100,
          c_Moneda: 'MXN'
        },
        country: {
          id: 151,
          c_Pais: 'MEX'
        },
        value: {
          periodType: '',
          deadline: ''
        },
        value_expenseComment: {
          fiscal: {
            comment_required: null
          },
          no_fiscal: {
            comment_required: null
          }
        },
        value_dateExtension: {
          dateExtension: ''
        },
        original: null
      },
      error: false,
      errorMessage: '',
      errors: {}, // for error messages from backend
      loading: false,
      loadingItems: true,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.settings')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-cog fa-fw icon-color'
    },
    weekDays () {
      return [
        {id: 1, name: this.$t('settings.weekDays.sunday')},
        {id: 2, name: this.$t('settings.weekDays.monday')},
        {id: 3, name: this.$t('settings.weekDays.tuesday')},
        {id: 4, name: this.$t('settings.weekDays.wednesday')},
        {id: 5, name: this.$t('settings.weekDays.thursday')},
        {id: 6, name: this.$t('settings.weekDays.friday')},
        {id: 7, name: this.$t('settings.weekDays.saturday')}
      ]
    },
    companySettings () {
      if (this.userLogged.company !== undefined) {
        return this.settings.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    periodLabel () {
      if (this.editedItem.value.periodType === 1) {
        return this.$t('setting.weekly')
      } else if (this.editedItem.value.periodType === 2) {
        return this.$t('setting.biweekly')
      } else if (this.editedItem.value.periodType === 3) {
        return this.$t('setting.monthly')
      } else {
        return this.$t('setting.weekly')
      }
    },
    days () {
      if (this.editedItem.value.periodType === 1) {
        return this.weekDays
      } else {
        return this.monthDays
      }
    },
    rules () {
      return this.$validationRules()
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('setting.add') : this.$t('setting.edit')
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('setting.type'),
          align: 'center',
          value: 'gst_setting_type_id',
          sortable: true
        },
        {
          text: this.$t('setting.value'),
          align: 'center',
          value: 'value',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.gst_setting_type_id' (val) {
      switch (val) {
        case 1:
          this.editedItem.value = {periodType: '', deadline: ''}
          this.editedItem.value_expenseComment = ''
          this.editedItem.value_dateExtension = ''
          break
        case 2:
          this.editedItem.value = ''
          this.editedItem.value_dateExtension = ''
          if (this.editedItem.company_id === 0) {
            this.editedItem.value_expenseComment = {
              fiscal: {
                comment_required: null
              },
              no_fiscal: {
                comment_required: null
              }
            }
          }
          break
        case 3:
          this.editedItem.value_expenseComment = ''
          this.editedItem.value = ''
          if (this.editedItem.company_id === 0) {
            this.editedItem.value_dateExtension = {dateExtension: ''}
          }
          break
        default:
          this.editedItem.value = {periodType: '', deadline: ''}
          this.editedItem.value_expenseComment = ''
          this.editedItem.value_dateExtension = {dateExtension: ''}
          break
      }
    },
    'editedItem.original' (val) {
      this.editedItem.value = val
    }
  },
  created () {
    this.initialize()
  },
  updated () {
    this.userLogged = store.state.userLogged
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    getPeriodType (id) {
      if (this.periodsType.length >= 1) {
        return this.periodsType.find(item => item.id === id).name
      }
    },
    getWeekDay (id) {
      return this.weekDays.find(item => item.id === id).name
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    countryFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    currencyFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    deleteItem (item) {
      const index = this.settings.indexOf(item)
      this.delete(item, index)
      this.removeDialog = false
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    editItem (item) {
      this.editedIndex = this.settings.indexOf(item)
      let setting = Object.assign({}, JSON.parse(JSON.stringify(item.value)))
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      if (setting.dateExtension !== undefined) {
        this.editedItem.value_dateExtension = setting
      } else if (setting.c_Moneda !== undefined) {
        this.editedItem.currency = this.satMoneda.find((currency) => {
          return currency.id === setting.id
        })
      } else if (setting.c_Pais !== undefined) {
        this.editedItem.country = this.satPais.find((country) => {
          return country.id === setting.id
        })
      } else {
        this.editedItem.value_expenseComment = setting
      }
      this.editedItem.original = item.value
      this.dialog = true
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    post () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let item = {
          company_id: this.userLogged.company[0].id,
          gst_setting_type_id: this.editedItem.gst_setting_type_id,
          value: null
        }
        if (this.editedItem.gst_setting_type_id === 2) {
          item.value = JSON.stringify(this.editedItem.value_expenseComment)
        } else if (this.editedItem.gst_setting_type_id === 3) {
          item.value = JSON.stringify(this.editedItem.value_dateExtension)
        } else if (this.editedItem.gst_setting_type_id === 1) {
          item.value = JSON.stringify(this.editedItem.value)
        } else if (this.editedItem.gst_setting_type_id === 4) {
          item.value = JSON.stringify(this.editedItem.currency)
        } else if (this.editedItem.gst_setting_type_id === 5) {
          item.value = JSON.stringify(this.editedItem.country)
        }
        this.$emit('settingsPost', { item: item, context: this })
      }
    },
    put () {
      let item = {
        company_id: this.userLogged.company[0].id,
        gst_setting_type_id: this.editedItem.gst_setting_type_id,
        value: null
      }
      if (this.editedItem.gst_setting_type_id === 2) {
        item.value = JSON.stringify(this.editedItem.value_expenseComment)
      } else if (this.editedItem.gst_setting_type_id === 3) {
        item.value = JSON.stringify(this.editedItem.value_dateExtension)
      } else if (this.editedItem.gst_setting_type_id === 1) {
        item.value = JSON.stringify(this.editedItem.value)
      } else if (this.editedItem.gst_setting_type_id === 4) {
        item.value = JSON.stringify(this.editedItem.currency)
      } else if (this.editedItem.gst_setting_type_id === 5) {
        item.value = JSON.stringify(this.editedItem.country)
      }
      this.$emit('settingsPut', { item: item, id: this.editedItem.id, context: this })
    },
    delete (item, index) {
      this.$emit('settingsDelete', { item: item, index: index, context: this })
    },
    initialize () {
      this.$emit('settingsInitial', {
        context: this })
      this.$emit('companysGet', {context: this})
      this.$emit('settingTypes', {context: this})
    },
    refresh () {
      this.$emit('refresh', {context: this})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings.component.vue